export var googleMapsKey = null;
export function setGoogleMapsKey(key) {
  googleMapsKey = key;
}
//# sourceMappingURL=services.js.map